export const api_urls = {
    VERIFY_DEALER_CODE: '/account/get-locations',
    SIGNUP: '/account/create',
    VALIDATE_EMAIL: '/account/validate',
    CUSTOMER_SIGNUP: '/account/create-customer',
    SIGN_IN_VERIFY_OTP: '/account/verify-otp',
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    FORGOT_PASSWORD: '/password/forgot',
    RESET_PASSWORD: '/password/reset',
    VERIFY_OTP: '/password/verify-otp',
    REFRESH_TOKEN: '/auth/refresh-token',
    USER_PROFILE: '/auth/user-profile',
    GET_DETAILS_BY_FED_TAX_ID: '/account/info',
    GET_LEGAL_REG_NAME_SUGGESTIONS: '/account/search',
    CREATE_APPLICATION: '/application/create',
    UPDATE_APPLICATION: '/application/update',
    PRICING_SUBMIT_APPLICATION: '/application/pricing',
    GET_ASSET_TYPE_INFO: '/application/asset-type',
    UPLOAD_DOC: '/document/upload',
    UPLOAD_FILES: '/document/upload-to-aspire',
    DELETE_DOC: '/document/delete',
    FINANCE_PRODUCT: '/application/finance-product',
    GET_APPLICATIONS_LIST: '/application/dashboard',
    GET_APPLICATIONS_DETAILS: '/application/details',
    GET_QUOTE_DETAILS: '/quote/details',
    GET_QUOTE_TIER_OPTIONS: '/quote/tier-config',
    GET_USER_PROFILE: '/auth/profile',
    GET_LOCATION_LIST: '/location/list',
    GET_DEALER_DETAILS: '/account/dealer-info',
    GET_PRICING_DETAILS: '/quote/pricing-options',
    GET_PAYMENT_OPTIONS: '/quote/payment-options',
    GET_RATE_OPTIONS: '/quote/rate-options',
    SAVE_QUOTE: '/quote/save',
    GET_FEES_AND_TAXES: '/application/fees-and-taxes',
    GET_TAX_RATES: '/tax/rates',
    GET_TOLERANCE_AND_DOCFEE: '/application/tolerance-details',
    GET_ADJUDICATION_DETAILS: '/application/contract-adjudication',
    UPLOAD_QUOTE_MAIL: '/quote/mail',
    DELETE_DRAFT_APPLICATION: '/application/delete',
    GET_HELP_EMAIL: '/account/help-info',
    GET_LOC_APPLICATION_LIST: '/application/line-of-credit',
    VENDOR_CONFIG_DETAILS: '/vendor/config-details',
    GET_DEEPLINK_CUSTOMER_METADATA: '/application/customer-form',
    SEND_CUSTOMER_APPLICATION: '/application/customer-form',
    GET_CUSTOMER_FORM_HISTORY_APPLICATIONS: 'application/customer-form/history',
    RESEND_CUSTOMER_APPLICATION_LINK: '/application/customer-form/resend',
    MARKETING_CONTENT: "/marketing-content/portal-list",
    GET_FIELD_CONFIG: "/vendor/field-config",
    SALES_ANALYTICS_INFO: "/application/sales-analytics-info",
    APPLICATION_COUNT_BY_STATUS: "/application/application-count-by-status",
    APPROVED_APPLICATION_BACKLOG: "/application/application-backlog-count",
    GET_LOC_AMOUNTS_INFO: 'application/loc-info',
    PROGRAMS_LIST: '/program/list',
    APPLICATION_PROGRAM_INFO: '/application/program-info',
    GET_SALES_REP_LIST: 'vendor/salesrep-list',
    GET_DEALER_LIST: '/dealer/list',
    GET_DASHBOARD_SALES_REP_LIST: 'location/list-salesreps',
    GET_QUOTE_LIST: '/quote/list',
    DELETE_QUOTE: '/quote/delete',
    PDF_PREVIEW_DOCUMENT_PACKAGE: '/document/package',
    CHATBOT_API_URL: 'chatbot/loanbot/',
    CHATBOT_TRANSCRIBE: 'chatbot/trascribe',
    TRANSLATION_LANGUAGE: '/account/language',
    GET_INSURANCE_QUOTE: '/insurance/generate-quote',
    GET_PORTAL_COMMENTS: '/application/comment',
    ADD_PORTAL_COMMENT: 'application/comment',
    OCR_DRIVER_LICENSE: '/document/ocr/driver-license',
    OCR_SALES_INVOICE: '/document/ocr/dealer-invoice',
    GET_FEES_ON_PROGRAM: '/program/fee-config',
    CREDIT_REASONS: '/application/credit-reasons',
    STATUS_REASONS: '/application/status-reasons',
    ACKNOWLEDGE_REASON: '/application/status-reasons/acknowledge',
    AUTO_SUBMIT: '/application/auto-submit',
    REASON_CATALOG: '/application-lookup/status-reasons',
    UPDATE_FEATURE_TOUR_STATUS: '/account/feature-tours',
};
